
<form (ngSubmit)="search(searchQuery)" class="search-container">
    <input type="text" [(ngModel)]="searchQuery" name="searchQuery" placeholder="Search..." (input)="search($event.target.value)" autocomplete="off">
    <button type="submit"><i class="bi bi-search"></i></button>
    <div class="search-results" *ngIf="(searchResults$ | async) as results">
      <ul *ngIf="results.length > 0">
        <li *ngFor="let result of results" (click)="onSelect(result)">
          {{ result.title }}
        </li>
      </ul>
    </div>
</form>
